module.exports = __webpack_public_path__ + "img/control-panel.13c0921d.png";